<template>
    <div id="app" v-cloak>
        <!-- 活动页 -->
        <!-- 完成弹窗打开时仍保留主页作为底层背景 -->
        <MainPage
            v-show="showPage == 'main' || showPage == 'finish'"
            @handleFinish="handleGoFinish"
            :lang="langarr"
            :language="language"
            :isOnRound="isOnRound"
            :bingoList="bingoList"
            :isTips="isTips"
        ></MainPage>
        <!-- 完成弹窗（半透明遮罩叠在主页之上） -->
        <FinishPage
            v-if="showPage == 'finish'"
            @handleCreated="handleCreated"
            :anniversaryCode="anniversaryCode"
            :bingoList="bingoList"
        ></FinishPage>
    </div>
</template>

<script>
import { myHTTP } from './utils/net'
import { lang } from '@/tool/archeroLang'
import FinishPage from '@/pages/finish'
import MainPage from '@/pages/main'
import arrList from '@/data/prize.js'
import { v4 as uuidv4 } from 'uuid'
import uaParser from 'ua-parser-js'

const ua = uaParser(navigator.userAgent)
import queryString from 'query-string'

let parsed = queryString.parse(location.search || '') || {}
export default {
    name: 'App',
    components: {
        FinishPage,
        MainPage
    },
    data() {
        return {
            isTips: false,
            isOnRound: false,
            isQuit: false,
            isShow: false,
            showPage: '',
            giftCode: '',
            language: '',
            lang2: '',
            langarr: [{}],
            bingoList: [],
            anniversaryCode: ''
        }
    },
    mounted() {
        for (let i in lang) {
            this.langarr[0][i] = lang[i][this.language]
        }
        // if (parsed.d || localStorage.getItem('d')) {
        //     this.isShow = true
        // }
    },
    created() {
        this.init()
        let type = ua.device.type
        if (type == 'mobile') {
            this.getLanguage()
        } else {
            alert('Currently not supported on PC')
            this.showPage = ''
            return
        }

        if (parsed.clear) {
            localStorage.clear()
            this.showPage = 'main'
        } else if (localStorage.getItem('uuid')) {
            this.initGift()
        } else if (localStorage.getItem('listBingo2026')) {
            this.bingoList = this.parseBingoList(localStorage.getItem('listBingo2026'))
            this.showPage = 'main'
        } else {
            localStorage.setItem('uuid', uuidv4())
            this.showPage = 'main'
            this.isTips = true
        }
        if (window.thinkingdata && typeof window.thinkingdata.track === 'function') {
            window.thinkingdata.track('anniversary2026_h5_event', {
                step: 'start'
            })
        }
    },
    methods: {
        parseBingoList(raw) {
            if (!raw) return []
            try {
                const list = typeof raw === 'string' ? JSON.parse(raw) : raw
                return Array.isArray(list) ? list : []
            } catch (e) {
                console.warn('parse listBingo2026 failed', e)
                return []
            }
        },
        ordersFromPrizeIds(rList) {
            const val = []
            const list = Array.isArray(rList) ? rList : []
            arrList.forEach(item => {
                list.forEach(it => {
                    if (String(item.prize_id) === String(it)) {
                        val.push(item.order)
                    }
                })
            })
            return val
        },
        goFinishWithCode(code, bingoOrders) {
            if (code) {
                this.anniversaryCode = code
                try {
                    localStorage.setItem('anniversaryCode2026', code)
                } catch (e) {}
            }
            const orders =
                Array.isArray(bingoOrders) && bingoOrders.length
                    ? bingoOrders
                    : this.parseBingoList(localStorage.getItem('listBingo2026'))
            this.handleGoFinish(orders)
        },
        // 是否已抽完本轮（3 或 6），应进完成页
        isBingoRoundDone(list) {
            const n = Array.isArray(list) ? list.length : 0
            return n >= 3
        },
        initGift() {
            // 恢复本地进度；页面跳转只在这里决策，避免 monopoly 恢复时抢先 emit
            this.bingoList = this.parseBingoList(localStorage.getItem('listBingo2026'))
            const localCode = localStorage.getItem('anniversaryCode2026') || ''
            const bingoDone = this.isBingoRoundDone(this.bingoList)

            if (localCode) {
                // 已有码 → 直接礼包码完成页
                this.goFinishWithCode(localCode, this.bingoList)
            } else if (bingoDone) {
                // 已抽完但还没本地码 → 完成页（分享/领取），不要先 main 再被 monopoly 推一次
                this.anniversaryCode = ''
                this.handleGoFinish(this.bingoList)
            } else {
                this.showPage = 'main'
            }

            const uuid = parsed.uuid || localStorage.getItem('uuid')
            myHTTP
                .post('/api/v1/anniversary2026/fetch', {
                    uuid,
                    giftCode: 'anniversary2026H5'
                })
                .then(res => {
                    if (res.data.code == 0) {
                        const serverCode = res.data.data && res.data.data.myGiftCode
                        if (serverCode) {
                            console.log('有礼包码', serverCode)
                            const rList =
                                (res.data.data.activityData && res.data.data.activityData.r) || []
                            let orders = this.ordersFromPrizeIds(rList)
                            if (!orders.length) {
                                orders = this.parseBingoList(localStorage.getItem('listBingo2026'))
                            }
                            this.goFinishWithCode(serverCode, orders)
                            return
                        }
                        // 服务端无码：保持当前页（可能已是 finish 分享，或 main），不要乱跳
                        // 若本地有码（极端情况）仍保持 finish
                        if (localStorage.getItem('anniversaryCode2026')) {
                            this.goFinishWithCode(
                                localStorage.getItem('anniversaryCode2026'),
                                this.bingoList
                            )
                        }
                    } else {
                        console.warn('fetch error code', res.data)
                        // 有码或已在 finish 则不动
                        if (
                            !this.anniversaryCode &&
                            !localStorage.getItem('anniversaryCode2026') &&
                            this.showPage !== 'finish'
                        ) {
                            alert(res.data.message)
                            this.showPage = 'main'
                        }
                    }
                })
                .catch(err => {
                    console.warn('initGift failed', err)
                    // 失败也不要从 finish  equ回 main
                    if (
                        !this.anniversaryCode &&
                        !localStorage.getItem('anniversaryCode2026') &&
                        this.showPage !== 'finish'
                    ) {
                        this.showPage = 'main'
                    }
                })
        },
        init() {
            ;(function (doc, win) {
                var docEl = doc.documentElement,
                    resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
                    recalc = function () {
                        var clientWidth = docEl.clientWidth
                        var clientHeight = docEl.clientHeight

                        if (!clientWidth) return
                        if (clientWidth < 1200) {
                            if (this.language === 'ja') {
                                docEl.style.fontSize = 14 * (clientWidth / 1080) + 'px'
                            } else {
                                docEl.style.fontSize = 16 * (clientWidth / 1080) + 'px'
                            }
                            if (clientWidth > 1023) {
                                if (this.language === 'ja') {
                                    docEl.style.fontSize = '16px'
                                } else {
                                    docEl.style.fontSize = '16px'
                                }
                            }
                        } else {
                            if (this.language === 'ja') {
                                docEl.style.fontSize = '16px'
                            } else {
                                docEl.style.fontSize = '18px'
                            }
                        }
                    }
                if (!doc.addEventListener) return
                win.addEventListener(resizeEvt, recalc, false)
                doc.addEventListener('DOMContentLoaded', recalc, false)
            })(document, window)
            // 禁止双指放大
            document.documentElement.addEventListener(
                'touchstart',
                function (event) {
                    if (event.touches.length > 1) {
                        event.preventDefault()
                    }
                },
                false
            )
            var lastTouchEnd = 0
            document.documentElement.addEventListener(
                'touchend',
                function (event) {
                    var now = Date.now()
                    if (now - lastTouchEnd <= 300) {
                        event.preventDefault()
                    }
                    lastTouchEnd = now
                },
                false
            )
            document.addEventListener('gesturestart', function (event) {
                event.preventDefault()
            })
        },
        getLanguage() {
            if (parsed.language) {
                this.language = parsed.language
            } else {
                var type = navigator.appName
                if (type == 'Netscape') {
                    var lang = navigator.language //获取浏览器配置语言，支持非IE浏览器
                } else {
                    var lang = navigator.userLanguage //获取浏览器配置语言，支持IE5+ == navigator.systemLanguage
                }
                this.language = lang
                if (lang == 'ko-KR') {
                    this.language = 'ko'
                }
                if (
                    ['en', 'ar', 'fr', 'de', 'id', 'ja', 'ko', 'pt', 'ru', 'es', 'th', 'es', 'tr', 'vi', 'it', 'zh-CN', 'zh-TW'].indexOf(
                        this.language
                    ) < 0
                ) {
                    this.language = 'en'
                }
            }
        },
        handleGoFinish(val) {
            if (Array.isArray(val)) {
                this.bingoList = val
                try {
                    localStorage.setItem('listBingo2026', JSON.stringify(val))
                } catch (e) {}
            }
            this.showPage = 'finish'
        },
        handleCreated() {
            // 分享成功：额外 3 次，回主页继续掷骰（仅未领码时）
            // 已有兑换码则留在完成页展示礼包码
            if (this.anniversaryCode || localStorage.getItem('anniversaryCode2026')) {
                const code = this.anniversaryCode || localStorage.getItem('anniversaryCode2026')
                this.goFinishWithCode(code, this.bingoList)
                return
            }
            this.showPage = 'main'
            this.isOnRound = true
        },
        // 退出登录
        handleQuit() {
            localStorage.removeItem('d')
            this.isQuit = false
            let path = this.$route.path
            window.location = path
            this.showPage = 'main'
        }
    }
}
</script>

<style  lang="less">
[v-cloak] {
    display: none;
}
/*公共样式--开始*/
html,
body,
div,
h1,
h2,
h3,
h4,
h5,
h6,
p,
form,
input,
textarea,
select {
    margin: 0 !important;
    padding: 0;
}
* {
    box-sizing: border-box;
}
img {
    border: none;
    vertical-align: middle;
    pointer-events: none;
}

a {
    text-decoration: none;
}

table {
    border-collapse: collapse;
    table-layout: fixed;
}
input,
textarea {
    outline: none;
    border: none;
}
#app {
    position: relative;
    margin: 0 auto !important;
    max-width: 1024px !important;
    overflow: hidden;
    font-family: CookieRunBold;
    background: url('./assets/images/anniversarybg.png') 100% 100% no-repeat;
    background-size: 100% 108%;
}
.quit {
    position: absolute;
    // top: 2.25rem;
    top: 0;
    // left: 2.25rem;
    left: 0.85rem;
    z-index: 2;
    transform: translateY(-2rem);
    img {
        // width: 4.25rem;
        width: 9.25rem;
    }
}
.loggedWrap {
    width: 100%;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.54);
    line-height: 1.2;
    .logged {
        position: absolute;
        width: 50%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -70%);
        background: #ffffff;
        width: 56.25rem;
        // box-shadow: 0px 8px 36px 0px rgba(0, 0, 0, 0.78);
        text-align: center;
        border-radius: 1.5rem;
        padding: 1.125rem 1.125rem 6.25rem;
    }
    .btn {
        height: 4rem;
        text-align: right;
        img {
            width: 4rem;
        }
    }
    p {
        height: 3rem;
    }
    .text {
        padding: 7.25rem 7.5rem;
        font-size: 2.25rem;
        span {
            color: #4380ff;
        }
    }
    .close {
        width: 39.5625rem;
        height: 9.4375rem;
        line-height: 9.4375rem;
        color: #ffffff;
        font-size: 3.125rem;
        display: inline-block;
        border-radius: 4.8125rem;
        background: #568dff;
    }
    .request {
        border: 2px solid #568dff;
        color: #568dff;
        background: #ffffff;
    }
}
</style>




// WEBPACK FOOTER //
// src/App.vue